import { CSSProperties, useMemo } from 'react';

import { Badge, withStyles } from '@material-ui/core';
import { STooltip } from '@setvi/shared/components';

import { useAppContext } from 'Providers/AppProvider/AppContext';

interface Props {
  disabled?: boolean;
  style?: CSSProperties;
  type?: 'private-label' | 'strategic-vendor';
}

const StyledBadge = withStyles(() => ({
  badge: {
    position: 'relative',
    transform: 'none',
    color: (props: any) => props.color || '#fff',
    backgroundColor: (props: any) => props.bgcolor || '#572BD3'
  }
}))(Badge);

export const ProductLabel = ({
  style,
  type = 'private-label',
  disabled
}: Props) => {
  const { productConfigurations } = useAppContext();

  const config = useMemo(() => {
    if (type === 'private-label') {
      return productConfigurations?.privateLabelConfig;
    }
    return productConfigurations?.strategicVendorConfig;
  }, [type, productConfigurations]);

  if (!config?.enabled) return null;

  return (
    <STooltip title={config.title} style={style}>
      <StyledBadge
        badgeContent={config.letter}
        color={disabled ? '#AFBAC6' : '#fff'}
        bgcolor={disabled ? '#EEF0F2' : config.color}
      />
    </STooltip>
  );
};
